export default function log(action, data = {}) {
	const out = {
		s: "seno",
		u: location.href,
		a: action,
		d: data,
	};

	const params: Array<string> = [];

	for (const entry of Object.entries(out)) {
		const key = entry[0];
		let value = entry[1];

		if (key === "d") {
			value = JSON.stringify(value);
		}
		params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
	}

	new Image().src = `//jslog.post.cz/hit/?${params.join("&")}`;
}
